import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

export const fetchDoctorAvailability = createAsyncThunk(
  "report/fetchDoctorAvailability",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(API_ENDPOINTS.DOCTOR_SLOTS, {
        params: credentials,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);
export const saveDiagnosis = createAsyncThunk(
  "report/saveDiagnosis",
  async (
    {
      appointmentId,
      chiefCompliant,
      diagnosis,
      notes,
      managementPlan,
      allergy,
      medication,
      surgeryHistory,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosInstance.post(
        `${API_ENDPOINTS.SAVE_DAIGNOSIS}?appointmentId=${appointmentId}`,
        {
          chiefCompliant,
          diagnosis,
          notes,
          managementPlan,
          allergy,
          medication,
          surgeryHistory,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const initialState = {
  availableSlot: {
    loading: false,
    error: null,
    data: null,
  },
};

// ------------------ SLICE ------------------
const SlotSlice = createSlice({
  name: "Slot",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorAvailability.pending, (state) => {
        state.availableSlot.loading = true;
        state.availableSlot.error = null;
      })
      .addCase(fetchDoctorAvailability.fulfilled, (state, action) => {
        state.availableSlot.loading = false;
        state.availableSlot.data = action.payload;
      })
      .addCase(fetchDoctorAvailability.rejected, (state, action) => {
        state.availableSlot.loading = false;
        state.availableSlot.error = action.payload;
      });
  },
});

export default SlotSlice.reducer;
